export default __webpack_public_path__ + "static/tooltip-truncation-dont-dark-32386a5f3b541707536f010c7c29cc5d.png";